import { get, post } from '../../../services/request';

// Fetch Volume Trend Reports Dropdown List
export const getVolumeTrendReportsDDList = async () => {
    try {
        const response = await get('ExamData/GetVolumeTrendReportsDDList');
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch Demand Table Reports with Pagination
export const getDemandTableReportsWithPagination = async (payload) => {
    try {
        const response = await post('DemandTable/GetDemandTableReportsWithPagination', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch Demand Input Onboarding Data
export const getDemandInputOnboardingData = async () => {
    try {
        const response = await get('DemandTable/GetDemandInputOnboardingData');
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch Notes Edit Data
export const getNotesEditData = async (payload) => {
    try {   
        const response = await post('Common/GetReportNote', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Save Notes Data
export const saveNotesData = async (payload) => {
    try {   
        const response = await post('Common/UpdateReportNote', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Export Reports Data
export const exportReportsData = async (payload) => {
    try {
        const response = await get(`DemandTable/ExportDemandTableReport?DemandTableId=${payload.DemandTableId}`);
        return response;
    } catch (error) {
        throw error;
    }   
};

// Delete Demand Report
export const deleteDemandReport = async (demandTableId) => {
    try {
        const response = await post(`DemandTable/DeleteDemandTableReport?DemandTableID=${demandTableId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// Get DemandTableID
export const getDemandTableByReport = (reportId, createdBy) => {
    return get(
        `DemandTable/GetDemandTableReport?ReportId=${reportId}&CreatedBy=${createdBy}`
    );
};

// Export Onboarding Data
export const exportOnboardingData = async (payload) => {
    try {
        const response = await get(`DemandTable/DemandInputOnboardingExportToCSV?DemandTableId=${payload.DemandTableId}`);
        return response;
    } catch (error) {
        throw error;
    }   
};

// Fetch Demand Input Filter Dropdown List
export const getDemandInputFilterDDList = async (reportId, DemandTableID) => {
    try {
        const response = await get(`DemandTable/GetDemandInputFilterDDList?ReportId=${reportId}&DemandTableId=${DemandTableID}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch Worklist By Site Dropdown List
export const getWorklistBySiteDropDown = async (siteIds) => {
    try {
        const response = await get(`DemandTable/GetWorklistBySiteDropDown?siteIds=${siteIds}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch Worklist With Site Mapping Dropdown List (Demand Changes Worklist sub-tab --
// worklists mapped to at least one facility, not scoped to a specific site).
export const getWorklistWithSiteMappingDropDown = async () => {
    try {
        const response = await get(`DemandTable/GetWorklistWithSiteMappingDropDown`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getWorklistByWorklistGroupDropDown = async (worklistGroupIds) => {
    try {
        const response = await get(`DemandTable/GetWorklistByWorklistGroupDropDown?worklistGroupIds=${worklistGroupIds}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// POST Demand Table (6th Tab) Pagination
export const getDemandTableWithPagination = async (payload) => {
    try {
        const response = await post('DemandTable/GetDemandTableDemandWithPagination', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// POST All Tabs Data by DemandTableReportID (Phase 2: endpoint moved GET -> POST)
export const getAllTabsDataById = async (payload) => {
    try {
        const {
            DemandTableReportID,
            ReportId,
            TabNumber,
            WorklistID,
            DayID,
            FacilityID,
            PriorityGroupID,
            GroupByFacility,
            GroupByPriorityGroup,
        } = payload || {};
        const response = await post('DemandTable/GetDemandTableById', {
            DemandTableReportID: DemandTableReportID ?? 0,
            ReportId: ReportId ?? 0,
            TabNumber: TabNumber ?? 0,
            WorklistID: WorklistID ?? null,
            DayID: DayID ?? null,
            FacilityID: FacilityID ?? null,
            PriorityGroupID: PriorityGroupID ?? null,
            GroupByFacility: GroupByFacility ?? false,
            GroupByPriorityGroup: GroupByPriorityGroup ?? false,
        });
        return response;
    } catch (error) {
        throw error;
    }
};

// Export Termed CSV
export const exportTermedCSV = async (payload) => {
    try {
        const response = await get(`DemandTable/TermedExportToCSV?ReportId=${payload.ReportId}&DemandTableId=${payload.DemandTableId}`);
        return response;
    } catch (error) {
        throw error;
    }   
};

// Export Offboarding CSV
export const exportOffboardingCSV = async (payload) => {
    try {
        const response = await get(`DemandTable/OffboardingExportToCSV?ReportId=${payload.ReportId}&DemandTableId=${payload.DemandTableId}`);
        return response;
    } catch (error) {
        throw error;
    }   
};

// Export Daylight Saving Ended CSV
export const exportDaylightSavingEndedCSV = async (payload) => {
    try {
        const response = await get(`DemandTable/GetDemandTableDayLightSavingEndedExportCSV?ReportId=${payload.ReportId}&DemandTableId=${payload.DemandTableId}`);
        return response;
    }
    catch (error) {
        throw error;
    }   
};

// Export Daylight Saving Upcoming CSV
export const exportDaylightSavingUpcomingCSV = async (payload) => {
    try {
        const response = await get(`DemandTable/GetDemandTableDayLightSavingUpcomingExportCSV?ReportId=${payload.ReportId}&DemandTableId=${payload.DemandTableId}`);
        return response;
    } catch (error) {
        throw error;
    }   
};

// DemandTable/GetDemandChangesSiteData API
export const getDemandChangesSiteData = async (payload) => {
    try {
        const response = await post('DemandTable/GetDemandChangesSiteData', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// DemandTable/GetDemandChangesPracticeData API
export const getDemandChangesPracticeData = async (payload) => {
    try {
        const response = await post('DemandTable/GetDemandChangesPracticeData', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Bulk Update Practice Data
export const bulkUpdateDemandChangesPracticeData = async (payload) => {
    const response = await post('DemandTable/BulkUpdateDemandChangesPracticeData', payload);
    return response;
};

// Bulk Update Site Data
export const bulkUpdateDemandChangesSiteData = async (payload) => {
    const response = await post('DemandTable/BulkUpdateDemandChangesSiteData', payload);
    return response;
};

// Bulk Delete Practice Data
export const bulkDeleteDemandChangesPracticeData = async (payload) => {
    try {
        const response = await post('DemandTable/BulkDeleteDemandChangesPracticeData', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Bulk Delete Site Data
export const bulkDeleteDemandChangesSiteData = async (payload) => {
    try {
        const response = await post('DemandTable/BulkDeleteDemandChangesSiteData', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// DemandTable/GetDemandChangesWorklistData API (Apply new Worklist demand change)
export const getDemandChangesWorklistData = async (payload) => {
    try {
        const response = await post('DemandTable/GetDemandChangesWorklistData', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Bulk Update Worklist Data
export const bulkUpdateDemandChangesWorklistData = async (payload) => {
    const response = await post('DemandTable/BulkUpdateDemandChangesWorklistData', payload);
    return response;
};

// Bulk Delete Worklist Data
export const bulkDeleteDemandChangesWorklistData = async (payload) => {
    try {
        const response = await post('DemandTable/BulkDeleteDemandChangesWorklistData', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Export Practice Data
export const exportPracticeData = async (payload) => {
    try {
        const response = await get(`DemandTable/DemandChangesPracticeExportToCSV?DemandTableId=${payload.DemandTableId}`);
        return response;
    } catch (error) {
        throw error;
    }   
};

// Export Site Data
export const exportSiteData = async (payload) => {
    try {
        const response = await get(`DemandTable/DemandChangesSiteExportToCSV?DemandTableId=${payload.DemandTableId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// Export Worklist Data
export const exportWorklistData = async (payload) => {
    try {
        const response = await get(`DemandTable/DemandChangesWorklistExportToCSV?DemandTableId=${payload.DemandTableId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// Refresh Demand Table Data
export const refreshDemandTableData = async (payload) => {
    try {
        const response = await post('DemandTable/GetDemandTableDemandRefreshData', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Save Draft Demand Table Report
export const saveDraftDemandTable = async (payload) => {
    const response = await post('DemandTable/DraftDemandTableReport', payload);
    return response; 
};

// Publish Demand Table Report
export const publishDemandTableReport = async (payload) => {
    try {
        const response = await post('DemandTable/PublishDemandTableReport', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch Holiday Coverage Worklist Data
export const getHolidayCoverageWorklistData = async (payload) => {
    try {
        const response = await post('DemandTable/GetDemandTableHolidayCoverageDetailsById', payload);
        return response;
    } catch (error) {
        throw error;
    }
};



